import moment from "moment";
import { statusColors, statusTranslator } from "../../../helpers/functions";
import { getEmailStatusInfo, getLatestTest, isTestFinished } from "../../../utils/test-invitation-link";

// Enviado y sin abrir hace más de un día: lo más probable es que el correo no le
// haya llegado (filtros de correo de empresa). Se avisa para usar el link directo.
const daysWithoutOpening = (test) => {
  if (![1, 2].includes(Number(test?.statusId)) || !test?.sentAt) return 0;
  return moment().diff(moment(test.sentAt), 'days');
};

// Estado del test vigente (el más reciente) de una persona, con avisos cuando el
// correo rebotó o el test lleva días sin abrirse. Se usa en las listas del panel.
const TestStatusBadge = ({ tests }) => {
  const latestTest = getLatestTest(tests);
  const statusId = latestTest?.statusId ?? 0;
  const days = daysWithoutOpening(latestTest);
  const email = isTestFinished(latestTest) ? null : getEmailStatusInfo(latestTest);
  return (
    <div>
      <div className={`gm-badge gm-badge--${statusColors(statusId)}`}>
        <span>{statusTranslator(statusId)}</span>
      </div>
      {email?.problem && (
        <small className="gm-badge-hint gm-badge-hint--error" title={email.tip}>
          {email.label}
        </small>
      )}
      {email?.fromMailbox && (
        <small className="gm-badge-hint gm-badge-hint--mailbox" title={email.label}>
          {latestTest.emailStatusDetail || email.label}
        </small>
      )}
      {!email?.problem && days >= 1 && (
        <small
          className="gm-badge-hint"
          title="Si no le llegó el correo, usa Reenviar test, Copiar link del test o Enviar por WhatsApp"
        >
          Sin abrir hace {days} {days === 1 ? 'día' : 'días'}
        </small>
      )}
    </div>
  );
};

export default TestStatusBadge;
